
(function(){
  const P = window.PK_PAGE || {};
  const grpOf = sec => sec.querySelector('figure.tile .ds')?.textContent;
  document.querySelectorAll('section.tiles-section').forEach(sec => {
    const g = grpOf(sec); if (!g) return;
    if ((P.exclude && P.exclude.includes(g)) || (P.only && (Array.isArray(P.only) ? !P.only.includes(g) : g !== P.only))) sec.remove();
  });
  if (P.only) { document.querySelector('.room-hero')?.remove(); document.querySelector('.pk-intro')?.remove(); }
})();
